/**
 * Converts a key/value object in a data-key=value object
 * @param dataObject object containing key/value pairs
 */
export const objectToDataAttributes = (dataObject: { [key: string]: any }): object => {
  const keyValues = Object.keys(dataObject).map((key) => {
    const newKey = `data-${key.toLowerCase()}`;
    return { [newKey]: dataObject[key] };
  });
  return Object.assign({}, ...keyValues);
};
